// Shared validation for naming a new connected account (instance) of a
// multi-instance OAuth integration. Used by the connect modals' submit
// handlers so the "required + unique" rules and their error copy can't drift
// between the OAuthIntegrationPairingModal and the DiscoveredUrlPairingModal.

// Returns an error message if `rawLabel` isn't a valid new account name given
// the labels already connected, or `null` if it's acceptable. Comparison is
// case-insensitive and ignores surrounding whitespace.
export function validateNewInstanceLabel(
  existingLabels: string[],
  rawLabel: string,
): string | null {
  const trimmed = rawLabel.trim();
  if (!trimmed) {
    return 'Please name this account so you can tell it apart from the others.';
  }
  const clash = existingLabels.some(
    (l) => l.toLowerCase() === trimmed.toLowerCase(),
  );
  if (clash) {
    return `You already have an account named "${trimmed}". Pick a different name.`;
  }
  return null;
}
